
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import Navbar from './include/Navbar'
import Footer from './include/Footer'
// import Hero from './components/Hero' // Not used in routes, but might be elsewhere
import Table from './pages/Table'
import Table2 from './pages/Table2'
import { CartProvider } from './pages/CartContext';
import Basket from './pages/Basket'
import Product from './pages/Product'
import Admin from './admin/Admin'
import Checkout from './pages/Checkout'
import CompressionSpringPage from './pages/CompressionSpringPage'
import { CurrencyProvider } from './components/utility/CurrencyContext';
import './App.css'
import Shopnow from './pages/Shopnow'
import ThankYouPage from './components/ThankYouPage'; // Import your ThankYouPage
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentForm from './pages/PaymentForm';

function Layout() {

  useEffect(() => {
    const handleRightClick = (e) => {
      // e.preventDefault();
    };

    const handleKeyDown = (e) => {
      // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U (view source)
      // if (
      //   e.key === 'F12' ||
      //   (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
      //   (e.ctrlKey && e.key === 'U')
      // ) {
      //   e.preventDefault();
      // }
    };

    document.addEventListener('contextmenu', handleRightClick);
    document.addEventListener('keydown', handleKeyDown);

    // Clean up the event listeners when the component unmounts
    return () => {
      document.removeEventListener('contextmenu', handleRightClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []); 

  const location = useLocation();
  const hideNavbarRoutes = ['/admin', '/razorpay'];
  const showNavbar = !hideNavbarRoutes.some(path => location.pathname.startsWith(path)) && (
    [
      '/',
      '/table',
      '/adddata', // Assuming this is a valid path where navbar should show
      '/basket',
      '/product',
      '/demo', // Assuming this is a valid path where navbar should show
      '/checkout',
      '/thank-you', // Added thank-you page to show navbar
    ].some((path) => location.pathname.startsWith(path)) ||
    location.pathname.startsWith('/shopnow/')
  );

  return (
    <div className='app-container'>
       <ToastContainer position="top-right" autoClose={5000} />
      {showNavbar && <Navbar />}
      <CurrencyProvider>
        <CartProvider className="bg-white">
          <Routes>
            {/* Main application routes */}
            <Route path="/" element={<Product />} />
            <Route path="/table" element={<Table />} />
            <Route path="/basket" element={<Basket />} />
            {/* Note: /payment is not currently routed in your provided App.js */}
            <Route path="/product" element={<Product />} />
            <Route path="/products2/:categoryId" element={<Table2 />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/quote" element={<CompressionSpringPage />} />
            <Route path="/shopnow/:id" element={<Shopnow />} />
            <Route path='/paymentform' element={<PaymentForm/>}/>

            {/* Admin route - make sure it handles its own sub-routes within Admin component */}
            <Route path="/admin/*" element={<Admin />} />
            {/* NEW: Thank You Page Route */}
            <Route path="/thank-you" element={<ThankYouPage />} />

          </Routes>
          {!hideNavbarRoutes.some(path => location.pathname.startsWith(path)) && <Footer />}
        </CartProvider>
      </CurrencyProvider>
    </div>
  );
}

export default function App() {
  return (
    <Router basename="/portal">
      <Layout />
    </Router>
  );
}